import React from 'react'
import { styled } from '@mui/material/styles'
import {
  BsFillMicFill,
  BsFillMicMuteFill,
  BsFillCameraVideoFill,
  BsFillCameraVideoOffFill,
} from 'react-icons/bs'

/**
 * Reusable circular control button with active / muted states.
 */
export const VideoControlButton = styled('button')<{ active?: boolean; muted?: boolean }>(
  ({ active, muted }) => ({
    backgroundColor: muted
      ? 'rgba(244, 67, 54, 0.8)'
      : active
      ? 'rgba(39, 174, 96, 0.8)'
      : 'rgba(0, 0, 0, 0.3)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'relative',
    transition: 'all 0.2s ease',
    // A disabled button must not look pressable: no hover brightening or scaling, no press.
    '&:hover:not(:disabled)': {
      backgroundColor: muted
        ? 'rgba(244, 67, 54, 1)'
        : active
        ? 'rgba(39, 174, 96, 1)'
        : 'rgba(0, 0, 0, 0.5)',
      transform: 'scale(1.05)',
      boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
    },
    '&:active:not(:disabled)': {
      transform: 'scale(0.95)',
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  })
)

// Lightweight wrappers so we can swap icon sets if needed later.
export const MicOnIcon: React.FC = () => (
  <IconWrapper>
    {React.createElement(BsFillMicFill as any)}
  </IconWrapper>
)

export const MicOffIcon: React.FC = () => (
  <IconWrapper>
    {React.createElement(BsFillMicMuteFill as any)}
  </IconWrapper>
)

export const CameraOnIcon: React.FC = () => (
  <IconWrapper>
    {React.createElement(BsFillCameraVideoFill as any)}
  </IconWrapper>
)

export const CameraOffIcon: React.FC = () => (
  <IconWrapper>
    {React.createElement(BsFillCameraVideoOffFill as any)}
  </IconWrapper>
)

const IconWrapper = styled('div')({
  color: 'white',
  filter: 'drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}) 